<template>
  <b-row>
    <b-col class="mb-4">
      <label><h4>Sélectionnez un autre représentant</h4></label>
      <v-multiselect
        :show-labels="false"
        :options="processedOptions(mandate)"
        group-values="items"
        group-label="group"
        :group-select="false"
        track-by="identifier"
        label="search"
        placeholder="Tapez pour rechercher"
        open-direction="bottom"
        @select="onSelect"
      >
        <template slot="option" slot-scope="props">
          <div v-if="props.option.$groupLabel">
            <strong class="text-primary">{{ props.option.$groupLabel }}</strong>
          </div>
          <div v-else class="d-flex">
            <div v-if="props.option.isParticipant" class="multiselect-participant-indicator" />
            <div class="w-75">
              <div class="select-option-main d-flex align-items-center">
                <span class="mr-2">
                  {{ props.option.name }}
                </span>
                <div v-if="votingLimitRules.votingLimitIsActive">
                  <appBOTantiemes :building-owner-data="props.option" />
                  <font-awesome-icon class="ml-2" icon="user-tag" />
                  <strong>
                    x
                    {{
                      props.option.type == "owner"
                        ? props.option.totalMandateVotes - 1
                        : props.option.totalMandateVotes
                    }}
                  </strong>
                </div>
              </div>
              <div class="select-option-description">
                {{
                  props.option.building_lots
                    ? props.option.building_lots.map(x => x.name).join(", ")
                    : ""
                }}
              </div>
            </div>
          </div>
        </template>
        <span slot="noResult" class="mx-2">
          Oops! Aucun élément trouvé. Pensez à modifier la requête de recherche.</span
        >
      </v-multiselect>
    </b-col>
  </b-row>
</template>

<script>
import meetingPresenceSelectOptionsMixins from "@/mixins/meeting-presence-select-options";

import appBOTantiemes from "@/components/snippets/BuildingOwnerTantiemes";

export default {
  components: {
    appBOTantiemes,
  },
  mixins: [meetingPresenceSelectOptionsMixins],

  props: {
    mandate: {
      type: Object,
      default: () => {
        return {};
      },
    },
    options: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  methods: {
    processedOptions(mandate) {
      if (this.votingLimitRules.votingLimitIsActive) {
        return this.getBOsCsShowedUpNotAbsentRestrictedOptions(this.options, mandate);
      } else {
        return this.options;
      }
    },
    onSelect(selectedParticipant) {
      this.$emit("onSelect", selectedParticipant);
    },
  },
};
</script>
